import React from 'react';
import PropTypes from "prop-types";

const ServerTime = (props) => {
    const {component: {}} = props;
    return (
        <div>
            Server Time
        </div>
    );
};

export default ServerTime;

ServerTime.propTypes = {
    component: PropTypes.shape({
        properties: PropTypes.shape({

        })
    })
}

ServerTime.defaultProps = {
    component: {}
}